import useSWR, { SWRConfiguration, SWRResponse } from 'swr';
import { AxiosError } from 'axios';
import { ScroogeProperty } from '../../../providers/api/dtos/scrooge';
import { getScroogePropertyById } from '../../../providers/api/scrooge/scroogeProvider';

export const USE_SCROOGE_PROPERTY_RID = '/scrooge/property/';

export default function useScroogeProperty(
  propertyId?: number,
  options?: SWRConfiguration<ScroogeProperty, AxiosError>,
): SWRResponse<ScroogeProperty, AxiosError> {
  const key = propertyId ? [USE_SCROOGE_PROPERTY_RID, propertyId] : null;

  return useSWR(key, () => getScroogePropertyById(propertyId!), options);
}
